import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 申請日時
 */
export class ApplyDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): ApplyDateTime {
    return new ApplyDateTime(value);
  }

  /** ラベル */
  static get label(): string {
    return '申請日時';
  }

  /** プレースホルダ */
  static get placeholder(): Date {
    return new Date('2022-01-01');
  }

  /** キー */
  static get key() {
    return 'applyDateTime';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
